import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { LinkDebtorResponseDialogComponent } from "../../organisms/link-debtor-response-dialog/link-debtor-response-dialog.component";
import { switchMap } from "rxjs/operators";
import { EmailService } from "../../../services/email.service";
import { ConfirmationDeleteModal } from "../../organisms/confirmation-delete-modal/confirmation-delete-modal.component";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { SaveResultComponent } from "src/app/shared/modules/overlay/ui/save-result/save-result.component";
import { ComponentPortal } from "@angular/cdk/portal";
import { Overlay } from "@angular/cdk/overlay";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-debtor-replies-pages",
  templateUrl: "./debtor-replies-pages.component.html",
  styleUrls: ["./debtor-replies-pages.component.scss"],
  animations: [
    trigger("drawerAnimation", [
      state("true", style({ height: "*", opacity: 1 })),
      state("false", style({ height: "0px", opacity: 0 })),
      transition("false <=> true", [animate("300ms ease-in-out")]),
    ]),
  ],
})
export class DebtorRepliesPagesComponent implements OnInit {
  emails = [];

  openStates = new Set<number>();

  selectedEmail;

  constructor(
    private emailService: EmailService,
    private dialog: MatDialog,
    private overlay: Overlay,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.getAllEmails();
  }
  getAllEmails() {
    this.spinner.show()
    this.emailService.getAllCompanies().subscribe((data) => {
      data?.forEach((email) => {
        email?.replies?.sort(
          (a, b) => new Date(a.date)?.getTime() - new Date(b.date)?.getTime()
        );
      });
      this.emails = this.removeOurReplies(data);
      this.spinner.hide()
    });
  }

  removeOurReplies(emails) {
    const phrase = "Estimados, muchas gracias por la información";

    return emails.map((email: any) => ({
      ...email,
      replies:
        email.replies?.filter(
          (reply) => {
            const hasPhrase = reply.body?.includes(phrase);
            const isFromBot = reply.from?.includes("bot@finsmart.pe");
            const shouldFilter = hasPhrase && isFromBot;
            return !shouldFilter;
          }
        ) || [],
    }));
  }

  toggleDrawer(index: number) {
    if (this.openStates.has(index)) {
      this.openStates.delete(index);
    } else {
      this.openStates.add(index);
    }
  }

  deleteEmail(id: string) {
    this.spinner.show()
    this.emailService
      .hideEmail(id)
      .pipe(switchMap(() => this.emailService.getAllCompanies()))
      .subscribe((data) => {
        this.emails = data;
        this.spinner.hide()
      });
  }

  openPopup(email: any) {
    this.selectedEmail = email;
    const dialogRef = this.dialog.open(ConfirmationDeleteModal, {
      width: "448px",
      panelClass: "confirmation-delete-dialog",
      disableClose: true,
    });

    dialogRef.componentInstance.confirmEvent.subscribe(() => {
      this.deleteEmail(this.selectedEmail._id);
      dialogRef.close();
    });

    dialogRef.componentInstance.cancelEvent.subscribe(() => {
      dialogRef.close();
    });
  }

  submit(replyId: string, emailId: string) {
    this.openModal(
      replyId,
      this.emails.find((em) => em.emailId === emailId)
    );
  }
  connectDialogListeners(dialogRef, callback) {
    dialogRef.afterClosed().subscribe(callback);
  }

  openModal(replyId: string, email: any) {
    const dialogRef = this.dialog.open(LinkDebtorResponseDialogComponent, {
      maxWidth: "100vw",
      width: "720px",
      maxHeight: "100vh",
      height: "100%",
      position: {
        left: "0",
      },
      autoFocus: false,
      data: { replyId: replyId, email: email },
    });
    this.connectDialogListeners(dialogRef, (result) => {
      if (result) {
        this.spinner.show();
        this.emailService.linkOperationsToEmail(result).subscribe({
          next: (res) => {
            if (res) {
              this.getAllEmails();
              this.openSaveResult();
              this.spinner.hide();
            }
          },
          error: (err) => {
            console.error("Error al vincular operaciones:", err);
          },
        });
      }
    });
  }

  openSaveResult() {
    const portalComponent = new ComponentPortal(SaveResultComponent);

    const overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: "dark-backdrop",
      panelClass: ["full-width", "reset-display"],
    });
    const componentRef = overlayRef.attach(portalComponent);
    componentRef.instance.success = { savingSucceeded: true };
    componentRef.instance.resultConfig = {
      onSuccess: {
        title: "Operaciones vinculadas",
        showIcon: true,
        iconName: "big-check-mark-icon",
      },
    };

    componentRef.instance.onDone.subscribe(() => {
      componentRef.destroy();
      overlayRef.dispose();
    });
  }
}
